import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { lastValueFrom } from 'rxjs';
import { DialogComponent, DialogDataWithTemplate } from '../components/dialog/dialog.component';

export interface DialogComponentInputs extends DialogDataWithTemplate {
  width: number;
  disableClose: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  constructor(private dialog: MatDialog) {}

  openModal = (
    inputs: DialogComponentInputs,
    configOverrides: Partial<DialogDataWithTemplate> = {}
  ): Promise<boolean> =>
    lastValueFrom(
      this.dialog.open(DialogComponent, buildConfig(inputs, configOverrides)).afterClosed()
    );

  openQuickModal = (content: string, configOverrides: Partial<DialogDataWithTemplate> = {}) => {
    const defaults = {
      header: 'Confirmation',
      yesText: 'Yes',
      noText: 'Cancel',
      isAffirmativeWarnColor: false,
      isAffirmativeBasicColor: false,
      isAffirmativeBasic: false,
      content: content,
      width: 450,
      disableClose: false,
      onOkay: () => Promise.resolve(true)
    };
    return this.openModal(defaults, configOverrides);
  };

  openDeleteModal = (
    itemToDelete: string = 'item',
    configOverrides: Partial<DialogDataWithTemplate> = {},
    width?: number
  ) => {
    const defaults = {
      header: 'Delete Confirmation',
      yesText: 'Delete',
      noText: 'Cancel',
      isAffirmativeWarnColor: true,
      content: `Are you sure you want to delete this <b>${itemToDelete}</b>?`,
      width: width ?? 450,
      disableClose: false,
      onOkay: () => Promise.resolve(true)
    };
    return this.openModal(defaults, configOverrides);
  };
}
const buildConfig = (
  defaults: Partial<DialogComponentInputs>,
  configOverrides: Partial<DialogDataWithTemplate>
): MatDialogConfig<DialogDataWithTemplate> => ({
  width: `${defaults.width ?? 683}px`,
  maxWidth: '95vw',
  disableClose: defaults.disableClose ?? true,
  data: {
    header: defaults.header,
    yesText: defaults.yesText,
    noText: defaults.noText,
    isAffirmativeWarnColor: defaults.isAffirmativeWarnColor ?? false,
    isAffirmativeBasicColor: defaults.isAffirmativeBasicColor ?? false,
    isAffirmativeBasic: defaults.isAffirmativeBasic ?? false,
    template: defaults.template,
    extraButtons: defaults.extraButtons,
    form: defaults.form,
    hideButtonBar: defaults.hideButtonBar ?? false,
    content: defaults.content,
    onOkay: defaults.onOkay,
    ...configOverrides
  }
});
